import { Controller } from "@hotwired/stimulus"
import { canvasResize } from "../lib/image_resize"
import { isObjectionable } from "../lib/nsfw"

// Resizes a chosen avatar to a small JPEG data URL client-side and submits it
// as a base64 column (avatar_data) — same approach as library photo thumbnails.
// Keeps image bytes out of Active Storage / the ephemeral disk and avoids any
// server-side image processing.
export default class extends Controller {
  static targets = ["input", "data", "form"]
  static values = { max: { type: Number, default: 256 } }

  async process() {
    const file = this.inputTarget.files[0]
    if (!file) return

    // Avatars keep their own (smaller, higher-quality) size, distinct from the
    // shared library-photo thumbnail.
    const data = await canvasResize(file, { max: this.maxValue, quality: 0.8 })
    if (!data) {
      console.warn("[avatar-upload] resize failed")
      return
    }

    // Objectionable-content filter (fail-open). Reject an explicit avatar.
    if (await isObjectionable(data)) {
      this.inputTarget.value = ""
      alert("That image can't be used as a profile photo.")
      return
    }

    this.dataTarget.value = data

    // Don't upload the raw (large) file — only the small base64 goes up.
    this.inputTarget.value = ""
    this.formTarget.requestSubmit()
  }
}
